import { ChangeDetectorRef, Directive, ErrorHandler, inject } from '@angular/core';
import { Router, RouterOutlet, Event } from '@angular/router';

import { combineLatest, debounceTime, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'rtc-detached-router-outlet',
})
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class DetachedRouterOutlet extends RouterOutlet {
  private cdRef = inject(ChangeDetectorRef);
  private context: Event[] = [];
  private ngOnDestroy$ = new Subject<void>();

  constructor(router: Router, private errorHandler: ErrorHandler) {
    super();
    router.events.pipe(takeUntil(this.ngOnDestroy$)).subscribe(event => {
      this.context = [event, ...this.context].slice(0, 50);
    });
  }

  public activateWith(): void {
    try {
      super.activateWith.apply(this, arguments);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.info(this.context);
      this.errorHandler.handleError(e);
    }
    this.cdRef.detectChanges();

    if (this['inputBinder']) {
      const { activatedRoute } = this;
      combineLatest([activatedRoute.queryParams, activatedRoute.params, activatedRoute.data])
        .pipe(debounceTime(0), takeUntil(this.ngOnDestroy$))
        .subscribe(() => this.cdRef.detectChanges());
    }
  }

  public ngOnDestroy() {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
    super.ngOnDestroy();
  }
}
